import React, { useState } from "react";

const AttachIcon = ({ isActive }) => {
  const [isHovered, setIsHovered] = useState(false);

  const fillColor = isActive ? "#EBF2F7" : isHovered ? "#1D4469" : "#969BA9";

  const bgColor = isActive ? "#1D4469" : "white";

  return (
    <span onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
        <rect
          x="0.5"
          y="0.5"
          width="32"
          height="32"
          rx="4.5"
          fill={bgColor}
          stroke={isHovered ? "#1D4469" : "#DFE2E5"}
        />

        <path
          d="M16.5 19.25C16.2239 19.25 16 19.0261 16 18.75V17H14.25C13.9739 17 13.75 16.7761 13.75 16.5C13.75 16.2239 13.9739 16 14.25 16H16V14.25C16 13.9739 16.2239 13.75 16.5 13.75C16.7761 13.75 17 13.9739 17 14.25V16H18.75C19.0261 16 19.25 16.2239 19.25 16.5C19.25 16.7761 19.0261 17 18.75 17H17V18.75C17 19.0261 16.7761 19.25 16.5 19.25Z"
          fill={fillColor}
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 9C10.7909 9 9 10.7909 9 13V20C9 22.2092 10.7909 24 13 24H20C22.2092 24 24 22.2092 24 20V13.6518C24 13.0975 23.7699 12.568 23.3646 12.1897L20.5234 9.53789C20.1531 9.19224 19.6653 9 19.1587 9H13ZM10 13C10 11.3432 11.3432 10 13 10H19V11.5C19 12.6046 19.8954 13.5 21 13.5H22.9884C22.9961 13.5499 23 13.6007 23 13.6518V20C23 21.6568 21.6568 23 20 23H13C11.3432 23 10 21.6568 10 20V13ZM20 11.5V10.4173L22.2315 12.5H21C20.4477 12.5 20 12.0523 20 11.5Z"
          fill={fillColor}
        />
      </svg>
    </span>
  );
};

export default AttachIcon;
